import { render, staticRenderFns } from "./loginRegister.vue?vue&type=template&id=9c080c92&scoped=true"
import script from "./loginRegister.vue?vue&type=script&lang=js"
export * from "./loginRegister.vue?vue&type=script&lang=js"
import style0 from "./loginRegister.vue?vue&type=style&index=0&id=9c080c92&prod&scoped=true&lang=css"
import style1 from "./loginRegister.vue?vue&type=style&index=1&id=9c080c92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c080c92",
  null
  
)

export default component.exports